import React, { useEffect, useRef } from 'react';
import type { LottiePlayer } from 'lottie-web';
import lottieLight from 'lottie-web/build/player/lottie_light.js';
import { Container } from './index.styles';
import animationData from '../../../assets/lottie/spinner';
export const sizes = ['xs', 'sm', 'md', 'lg', 'xl'] as const;

export interface SpinnerProps extends Component {
  /**
   * Spinner size. Optional.
   */
  size?: (typeof sizes)[number];
}

/**
 * Spinner
 */
export const Spinner = (props: SpinnerProps) => {
  const { className = '', customClass = '', testId = 'spinner' } = props;
  const lottie = lottieLight as unknown as LottiePlayer;
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!ref.current) return;

    const instance = lottie.loadAnimation({
      animationData,
      container: ref.current,
      renderer: 'svg',
    });

    instance.setSpeed(0.66);

    return () => {
      instance.destroy();
    };
  }, []);

  return (
    <Container
      {...props}
      ref={ref}
      className={`spinner ${customClass} ${className}`}
      data-testid={testId}
    />
  );
};
